import currency from 'currency.js';

export const formatToDecimals = (amount: number): number => currency(amount).divide(100).value;
